import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";

function ClassesFilters({
  weeks,
  weeksLoading,
  formatWeekLabel,
  selectedWeek,
  setSelectedWeek,
  selectedCampus,
  setSelectedCampus,
  selectedAge,
  setSelectedAge,
  selectedEnglishLevel,
  setSelectedEnglishLevel,
  selectedClass,
  setSelectedClass,
  nameSearch,
  setNameSearch,
  campusOptions,
  ageOptions,
  levelOptions,
  classOptions,
  showStudentFilters = true,
}) {
  const weekDisabled = !selectedCampus;

  return (
    <Box mb={3}>
      <Stack
        direction="row"
        spacing={2}
        flexWrap="wrap"
        justifyContent="center"
        useFlexGap
      >
        <FormControl sx={{ minWidth: 200 }} size="small">
          <InputLabel>Campus</InputLabel>
          <Select
            value={selectedCampus}
            label="Campus"
            onChange={(e) => setSelectedCampus(e.target.value)}
          >
            <MenuItem value="">Select Campus</MenuItem>
            {campusOptions.map((campus) => (
              <MenuItem key={campus.value} value={campus.value}>
                {campus.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200 }} size="small" disabled={weekDisabled}>
          <InputLabel>Week</InputLabel>
          <Select
            value={selectedWeek?.id ?? ""}
            label="Week"
            onChange={(e) =>
              setSelectedWeek(
                weeks.find((w) => w.id === e.target.value) || null
              )
            }
          >
            {weeks.map((week) => (
              <MenuItem key={week.id} value={week.id}>
                {formatWeekLabel ? formatWeekLabel(week) : `Week ${week.weekNumber}`}
              </MenuItem>
            ))}
          </Select>
          {weekDisabled && <FormHelperText>Pick a campus first</FormHelperText>}
          {!weekDisabled && weeksLoading && <FormHelperText>Loading weeks…</FormHelperText>}
          {!weekDisabled && !weeksLoading && weeks.length === 0 && (
            <FormHelperText>No weeks for this campus/year</FormHelperText>
          )}
        </FormControl>

        {showStudentFilters && (
          <>
            <FormControl sx={{ minWidth: 200 }} size="small">
              <InputLabel>Age</InputLabel>
              <Select
                value={selectedAge}
                label="Age"
                onChange={(e) => setSelectedAge(e.target.value)}
              >
                <MenuItem value="">All Ages</MenuItem>
                {ageOptions.map((age) => (
                  <MenuItem key={age} value={age}>
                    {age}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 200 }} size="small">
              <InputLabel>Level</InputLabel>
              <Select
                value={selectedEnglishLevel}
                label="Level"
                onChange={(e) => setSelectedEnglishLevel(e.target.value)}
              >
                <MenuItem value="">All Levels</MenuItem>
                {levelOptions.map((level) => (
                  <MenuItem key={level} value={level}>
                    {level}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 200 }} size="small">
              <InputLabel>Class</InputLabel>
              <Select
                value={selectedClass}
                label="Class"
                onChange={(e) => setSelectedClass(e.target.value)}
              >
                <MenuItem value="">All Classes</MenuItem>
                {classOptions.map((className) => (
                  <MenuItem key={className} value={className}>
                    {className}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Search Name"
              variant="outlined"
              size="small"
              value={nameSearch}
              onChange={(e) => setNameSearch(e.target.value)}
              sx={{ minWidth: 200 }}
            />
          </>
        )}
      </Stack>
    </Box>
  );
}

export default ClassesFilters;
